export default __webpack_public_path__ + "assets/svg/close_icon_red.8a7137f455a5e1349b8947a5e3255a85.svg";